export default "/images/arrow-up.svg?997ba192b22f6639573ef36964e9d7b7";